import { render } from "./RFIPagination.vue?vue&type=template&id=1e12fe20"
import script from "./RFIPagination.vue?vue&type=script&lang=js"
export * from "./RFIPagination.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__